import React from "react";

export default propsToHOC => Component =>
  class extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        Component: null
      };
    }

    componentDidMount() {
      this.setState({
        Component: propsToHOC(this.props)(Component)
      });
    }

    render() {
      const { Component } = this.state;

      return Component && <Component />;
    }
  };



// WEBPACK FOOTER //
// ./src/core/react/hoc/withHOC.js